module.exports = __webpack_public_path__ + "img/默认头像@2x.a2498e24.png";